import Repository from "../Repository";

const resource = "/reportings";
export default {
    get() {
        return Repository.get(`${resource}`);
    },
    getReporting(id) {
        return Repository.get(`${resource}/${id}`);
    },
    create(json) {
        return Repository.post(`${resource}`, json);
    },
    update(id, json) {
        return Repository.put(`${resource}/${id}`, json);
    },
    delete(id) {
        return Repository.delete(`${resource}/${id}`);
    }
}